<script setup>
import { cn } from "@/lib/utils";
import {
  DropdownMenuItemIndicator,
  DropdownMenuRadioItem,
  useForwardPropsEmits,
} from "reka-ui";
import { IconCheck } from "@tabler/icons-vue";
import { computed } from "vue";

const props = defineProps({
  class: {
    type: [String, Array, Object],
    default: "",
  },
});

const emits = defineEmits(["update:modelValue", "change"]);

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <DropdownMenuRadioItem
    v-bind="forwarded"
    :class="
      cn(
        'vf-relative vf-flex vf-cursor-default vf-select-none vf-items-center vf-rounded-sm',
        'vf-py-1.5 vf-px-2 vf-text-sm vf-outline-none vf-transition-colors focus:vf-bg-accent data-[state=checked]:vf-bg-neutral-100',
        'focus:vf-text-accent-foreground data-[disabled]:vf-pointer-events-none data-[disabled]:vf-opacity-50',
        props.class
      )
    "
  >
    <slot />
    <span
      class="vf-absolute vf-right-2 vf-flex vf-h-3.5 vf-w-3.5 vf-items-center vf-justify-center"
    >
      <DropdownMenuItemIndicator>
        <IconCheck size="20" color="var(--primary-400)" />
      </DropdownMenuItemIndicator>
    </span>
  </DropdownMenuRadioItem>
</template>
